<template>
  <div>
    <div :class="breakline?`orderedBeside ml-4 mr-4`:`orderedBesidenobreaklined ml-4 mr-4`">
      <v-row style="justify-content: flex-end !important;">
        <template v-if="enableDate">
          <v-col cols="12" md="2" lg="2">
            <v-checkbox
              v-model="filterForDate"
              label="Usar fechas"
              dense
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <date-picker :disbaled="!filterForDate"  label="Fecha inicio" @dateSelected="(param) => {startDate = param; $emit('getStart', param) }" class="mx-1" />
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <date-picker :disbaled="!filterForDate" label="Fecha fin" @dateSelected="(param) => {endDate = param; $emit('getEnd', param) }" class="mx-1" />
          </v-col>
        </template>
        <v-col class="col-7-input" style="display: flex; flex-wrap: nowrap;" :cols="twoSlots ? 10 : 12" md="4" lg="6">
          <!--v-text-field ref="filterInput" outlined dense label="Buscar..." v-model="search.filter"
            @input="handleEmptyFilter" @keyup.enter="filterHandler"></v-text-field-->
          <v-text-field ref="filterInput" outlined dense label="Buscar..." v-model="search.filter"
            @keyup.enter="filterHandler"></v-text-field>
          <v-btn ref="filterButton" class="btn-save" style="margin-left: 2%;"
            @click="filterHandler"><v-icon>mdi-magnify</v-icon></v-btn>
          <template v-if="!advancedFilter">
            <GeneralColumnsFilter v-if="columns" :columns="columns" @onColumns="filterByColumns($event)" />
          </template>
        </v-col>
        <!-- advanced filter -->
        <v-col v-if="advancedFilter" cols="12">
         <GeneralFilterForm 
           :columns.sync="columns" 
           @onFilter="filterByColumns(columns)" 
           @onClean="onCleanAdvancedFilter"
           :showBranchSelector="showBranchSelector"
           :selectedBranch="selectedBranch"
           :branches="branches"
           :currentBranch="currentBranch"
           @onBranchChange="onBranchChange"
           :showAllRecords="showAllRecords"
           :showAllRecordsToggle="showAllRecordsToggle"
           @onShowAllRecordsChange="onShowAllRecordsChange"
           :alternativeColumnsFilterStyle="alternativeColumnsFilterStyle"
         />
        </v-col>
      </v-row>
    </div>
    <div>
      <div :style="!isAutoScrolled && 'overflow-x:scroll;'">
        <slot> </slot>
      </div>
      <div v-if="!hideLimitLabel" class="d-flex justify-center mt-1 mb-2">
        <p v-if="!showAllRecords">En la prevista se muestras los últimos 100 registros agregados</p>
        <p v-else>Mostrando todos los registros disponibles</p>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralColumnsFilter from './GeneralColumnsFilter.vue';
import GeneralFilterForm from './GeneralFilterForm.vue';
import DatePicker from '@/components/DatePicker'
export default {
  name: "GeneralFilter",
  components: {
    GeneralColumnsFilter,
    GeneralFilterForm,
    DatePicker,
  },
  props: {
    showAllRecordsToggle: {
      type: Boolean,
      default: false
    },
    advancedFilter: {
      type: Boolean,
      default: false
    },
    filterEndpoint: {
      type: Function,
      default: null,
    },
    columnsFilterEndpoint: {
      type: Function,
      default: null,
    },
    search: {
      type: Object,
      default: null,
    },
    hideLimitLabel: {
      type: Boolean,
      default: false,
    },
    isAutoScrolled: {
      type: Boolean,
      default: false,
    },
    twoSlots: {
      type: Boolean,
      default: false,
    },
    breakline: {
      type:Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: null
    },
    prefixColumn: {
      type: Boolean,
      default: false
    },
    showBranchSelector: {
      type: Boolean,
      default: false
    },
    selectedBranch: {
      type: [String, Number],
      default: null
    },
    branches: {
      type: Array,
      default: () => []
    },
    currentBranch: {
      type: String,
      default: ''
    },
    showAllRecords: {
      type: Boolean,
      default: false
    },
    alternativeColumnsFilterStyle: {
      type: Boolean,
      default: false
    },
    enableDate: {
        type: Boolean,
        default: false
    }
    
  },

  data() {
    return {
      filter: null,
      twoSlotss: this.twoSlots,
      startDate: null,
      endDate: null,
      filterForDate: false,
    };
  },
  watch: {
    filter(newVal) {
      this.$emit("input", newVal);
    },
    
  },
  methods: {
    focusInput() {
      this.$refs.filterInput.focus();  // Asegúrate de que filterInput es el ref del v-text-field
    },
    handleEmptyFilter() {
      if (this.search.filter.length === 0) {
        this.$emit("emptyFilter");
      }
    },
    filterHandler() {
      if ((this.search.filter?.length != 0 && this.search.filter) || this.filterForDate) {
        this.$emit("loading", true)
        let searchWithLimit = {
          ...this.search,
          showAllRecords: this.showAllRecords
        };
        if (this.filterForDate) {
          searchWithLimit.startDate =  this.startDate;
          searchWithLimit.endDate = this.endDate;
        }
        
        this.filterEndpoint(searchWithLimit)
          .then((response) => {
            this.$emit("filtered", response);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$emit("loading", false)
          })
      } else {
        this.$emit("emptyFilter");
      }
    },
    filterByColumns(columns) {
      const columnsQueryParams = !this.alternativeColumnsFilterStyle ? this.makeQueryObjectFromColumns( columns ) : this.makeQueryArrayFromColumns( columns );
      let queryParams = columnsQueryParams;

      if( !this.alternativeColumnsFilterStyle ) {
        if (this.prefixColumn){
          queryParams = {
            ...queryParams,
            ...this.search
          }
        } else {
          queryParams = {
            ...queryParams
          }
        }
      } else {
        queryParams = {
          columnsFilter: [ ...queryParams ]
        }
      }

      this.$emit("loading", true)
      this.columnsFilterEndpoint({ ...queryParams, showAllRecords: this.showAllRecords })
        .then((response) => {
          this.$emit("filtered", response);
        })
        .catch((error) => {
          console.log(error);
          this.$emit("emptyFilter");
        })
        .finally(() => {
          this.$emit("loading", false)
        })
    },
    makeQueryArrayFromColumns( columns ) {
      const queryParam = [];

      columns.forEach( column => {
        const currentObj = {};
        if( column.type === 'between' ) {
          currentObj.key = column.name;
          currentObj.from = column.from;
          currentObj.to = column.to;
          currentObj.type = column.type;
        } else {
          currentObj.key = column.name;
          currentObj.value = column.value;
          currentObj.type = column.type;
        }
        
        queryParam.push( currentObj );
      } );

      return queryParam;
    },
    makeQueryObjectFromColumns(columns) {
      const queryParam = {}
      columns.forEach(column => {
        let paramKey = column.name
        if (this.prefixColumn) {
          paramKey = `column_${column.name}`
        }
        // Verificar que el valor no sea nulo ni vacío
        if (column.value !== null && column.value !== undefined && column.value !== "") {
          // Si es string, hacer trim, sino usar el valor directamente
          const cleanValue = typeof column.value === 'string' ? column.value.trim() : column.value
          if (cleanValue !== "") {
            queryParam[paramKey] = cleanValue
          }
        }
      })
      return queryParam
    },
    onCleanAdvancedFilter() {
      const columns = JSON.parse(JSON.stringify(this.columns))
      columns.forEach((column) => {
        column.value = ""
      })
      this.$emit("update:columns", columns)
      this.$emit("emptyFilter");
    },
    onBranchChange(value) {
      this.$emit("onBranchChange", value)
    },
    onShowAllRecordsChange(value) {
      this.$emit("onShowAllRecordsChange", value)
    }
  },
};
</script>

<style scoped>
.orderedBeside {
  @media screen and (min-width: 1068px) {padding-top: 44px;}
  
}

.orderedBesidenobreaklined {
  padding-top: 44px !important;
}

.break-line {
  display: none; /* Oculta por defecto */
}

@media (max-width: 1217px) and (min-width: 1069px) { /* Activa el salto de línea solo bajo 1200px */
  .break-line {
    display: block;
    width: 100%;
    height: 60px; /* Mantiene el div sin altura */
  }
}
</style>
